import React, { useContext } from "react"
import PropTypes from "prop-types"
import {Modal, Button, Form } from "react-bootstrap"
import { ModalContext } from "../layout"

function NotifyMeModal({notifyMeEmail, onModalClose}) {
    const [showModal, setShowModal] = useContext(ModalContext)
    const handleClose = () => {
        onModalClose && onModalClose();
        setShowModal(false);
    }

    return (
        <Modal show={showModal} onHide={handleClose} centered>
            <Modal.Header style={{ backgroundColor: "#FDB523" }}>
                <Modal.Title>You are in our Queue</Modal.Title>
            </Modal.Header>
            <Form name="Notify Me Form" method="POST" action="/public-portfolios#notify-me-email-form">
                <Modal.Body>
                    <input type="hidden" name="form-name" value="Notify Me Form" />
                    <Form.Group className="mb-3" controlId="formEmail">
                        <Form.Label netlify>Email address</Form.Label>
                        <span style={{ color: '#6C757D', paddingLeft: '2em' }}>{notifyMeEmail}</span>
                        <Form.Control
                            type="email"
                            name="email"
                            value={notifyMeEmail}
                            placeholder="your email address"
                            className="d-none"
                            required
                        />
                    </Form.Group>
                    <p className="my-3">Provide us more information</p>
                    <Form.Group className="mb-3" controlId="formFullName">
                        <Form.Label>Full name</Form.Label>
                        <Form.Control
                            type="text"
                            name="fullName"
                            placeholder="John Doe"
                            required
                        />
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="formCompanyName">
                        <Form.Label>Company website</Form.Label>
                        <Form.Control
                            type="url"
                            name="company"
                            placeholder="https://www.example.com/"
                            required
                        />
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="formCompanyRole">
                        <Form.Label>Company Role</Form.Label>
                        <Form.Control
                            type="text"
                            name="companyRole"
                            placeholder="CEO, Sales, Engineer"
                            required
                        />
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        className="px-4 mt-3"
                        variant="secondary"
                        style={{
                            borderRadius: "8px",
                        }}
                        onClick={handleClose}
                    >
                        Close
                    </Button>
                    <Button
                        className="px-4 mt-3"
                        type="submit"
                        variant="primary"
                        style={{
                            background: "#FDB523",
                            borderRadius: "8px",
                        }}
                    >
                        Submit
                    </Button>
                </Modal.Footer>
            </Form>
        </Modal>
    )
}

NotifyMeModal.propTypes = {
    showModal: PropTypes.bool,
    closeModal: PropTypes.func,
}

export default NotifyMeModal
